module.exports = __webpack_public_path__ + "static/img/img-01.e40e58eb.png";